/**
 * 統一日誌管理工具
 * 只在開發環境輸出日誌，生產環境靜默
 */
/* eslint-disable no-console */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log(...args) {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  error(...args) {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  warn(...args) {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  info(...args) {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  debug(...args) {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

// 為了向後相容，也可以直接導出個別方法
export const { log, error, warn, info, debug } = logger;